<script lang="ts">
	import coffee2xl from "@assets/images/coffee.jpg?webp&imagetools";
	import coffeeXs from "@assets/images/coffee.jpg?webp&w=640&imagetools";
	import coffeeMd from "@assets/images/coffee.jpg?webp&w=1024&imagetools";
	import coffeeXl from "@assets/images/coffee.jpg?webp&w=1440&imagetools";
	import BuildYourSubscriptionButton from "@components/BuildYourSubscriptionButton.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import Media from "@components/common/Media.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import translations from "./FathersClubPricingSection.translations.json" with { type: "json" };
	import FathersClubSavingsStats from "./FathersClubSavingsStats.svelte";

	const translate = getTranslate(translations);
</script>

<section class="full-width grid-container relative overflow-hidden py-12 sm:py-14 xl:py-16 2xl:py-20">
	<Media
		source={{ type: "image/webp", src: coffeeXs }}
		sourcesets={{ ">md": coffeeMd, ">xl": coffeeXl, ">2xl": coffee2xl }}
		width={1440}
		height={960}
		alt=""
		class="size-full object-cover"
		wrapperClass="absolute inset-0 full-width"
	/>
	<div class="absolute inset-0 bg-black/40 full-width"></div>
	<div
		class="relative z-10 bg-fcrbeige w-full p-8 gap-8 sm:p-10 xl:p-12 lg:items-center lg:min-h-107 flex flex-col lg:flex-row"
	>
		<div class="flex-1 flex uppercase flex-col gap-5">
			<div class="text-fcrorange font-bold tracking-[.1em] text-sm">
				<Formatted text={translate("caption")} />
			</div>
			<Heading level={2} text={translate("title")} class="font-antipol font-medium text-8/tighter text-fcrdarkgray" />
			<p class="mb-2 text-base font-bold tracking-[.16em] max-w-100">
				<Formatted text={translate("subtitle")} />
			</p>
			<BuildYourSubscriptionButton variant={ButtonVariant.White} class="w-fit" />
		</div>
		<FathersClubSavingsStats />
	</div>
</section>
